<script lang="ts">
	import { Button, Headline } from '@atoms';
	import ListOfThumbs from './ListOfThumbs.svelte';
	import { type ImageData } from '@queries/datoCMS/DatoCMSQueries';
	import { createViewController, ViewController } from '$lib/actions/animations/ViewController';
	import { EnterOnView } from '$lib/actions/animations/EnterOnView';

	let {
		headline,
		items,
		onLoadMore,
		onViewMore,
		loadMoreText = 'Se flere',
		viewMoreText = 'Se alle',
		layout = 'reference',
		isLoading = false
	}: {
		headline?: string;
		items: {
			published?: string;
			description: string;
			media: ImageData;
			path: string;
		}[];
		layout?: string;
		isLoading?: boolean;
		onLoadMore?: () => void;
		onViewMore?: () => void;
		viewMoreText?: string;
		loadMoreText?: string;
	} = $props();

	createViewController();
</script>

<section use:ViewController>
	<div class={layout} use:EnterOnView>
		<Headline text={headline}>
			{#if onViewMore}
				<Button onclick={onViewMore}>{viewMoreText}</Button>
			{/if}
		</Headline>
	</div>

	<ListOfThumbs {items}></ListOfThumbs>

	{#if onLoadMore}
		<div class="btn-container" use:EnterOnView>
			{#if isLoading}
				<Button>Loader...</Button>
			{:else}
				<Button onclick={onLoadMore}>{loadMoreText}</Button>
			{/if}
		</div>
	{/if}
</section>

<style lang="scss">
	section {
		@include pagePadding;
		@include blockPadding;
	}

	.reference {
		padding-bottom: 0;
		margin-bottom: 34px;
	}

	.full {
		margin-bottom: 116px;

		@include md {
			padding-bottom: $padding-mini;
		}
	}

	.btn-container {
		display: flex;
		justify-content: center;
		padding-top: $padding;
	}
</style>
